import { render, staticRenderFns } from "./AltCard.vue?vue&type=template&id=6224836f&"
import script from "./AltCard.vue?vue&type=script&lang=ts&"
export * from "./AltCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports